export default __webpack_public_path__ + "static/media/strasbourg2.582d1273.jpg";